var map = {
	"./18-play-responsibly.png": "6203",
	"./18-plus-chile.png": "ff5c",
	"./18-plus-dk.png": "332e",
	"./18-plus-serbia.png": "1e4e",
	"./18-plus.png": "bf85",
	"./21-plus.png": "1928",
	"./24x7handsnl.png": "3096",
	"./800-gambler.png": "f129",
	"./adg-problem-gambling.png": "4dbe",
	"./agognl.png": "2a18",
	"./bell-icon.png": "2b20",
	"./br-flag.png": "8d90",
	"./ca-flag.png": "fb2c",
	"./cards.png": "fc4b",
	"./casino.png": "2687",
	"./check.png": "e209",
	"./cl-flag.png": "0e2a",
	"./close-cross.png": "9aa9",
	"./co-flag.png": "a1e6",
	"./crown.png": "e599",
	"./cruksnl.png": "3013",
	"./dk-flag.png": "b207",
	"./drajzerova-logo-first.png": "2f10",
	"./drajzerova-logo-second.png": "e856",
	"./ecogra.png": "7e24",
	"./envelope-icon.png": "3a46",
	"./es-flag.png": "cfee",
	"./evalu-jeu.png": "89f7",
	"./extern.png": "11a4",
	"./facebook-icon.png": "9795",
	"./fi-flag.png": "3344",
	"./football-helmet.png": "76fc",
	"./fr-flag.png": "6aa7",
	"./gam-stop.png": "7ef1",
	"./gamble-aware.png": "c199",
	"./gamblers-anonymous.png": "6a8c",
	"./gambling-care.png": "471e",
	"./gambling-therapy.png": "7e21",
	"./gamcare.png": "58ee",
	"./giftbox.png": "535c",
	"./gordon-moody.png": "d59c",
	"./horse.png": "c612",
	"./ie-flag.png": "35b0",
	"./igc.png": "af79",
	"./info-i.png": "78ed",
	"./info.png": "e810",
	"./it-flag.png": "459a",
	"./jackpot.png": "3125",
	"./jogadoresanonimosbr.png": "f8b8",
	"./juega-bien.png": "caca",
	"./juegosysorteos-mx.png": "502e",
	"./loketkansspelnl.png": "8a7a",
	"./ludomani.png": "d957",
	"./mapg.png": "2886",
	"./michigan-gaming-control-board.png": "2bb4",
	"./mx-flag.png": "de4e",
	"./ncpg.png": "39e4",
	"./nj-responsible-gambling.png": "abb7",
	"./nl-flag.png": "de41",
	"./onjn-romania.png": "f713",
	"./pa-responsible-gambling.png": "44b0",
	"./pe-flag.png": "9bae",
	"./pt-flag.png": "e1ef",
	"./rofus.png": "de94",
	"./roulette.png": "50b1",
	"./rs-flag.png": "4071",
	"./safe.png": "3108",
	"./se-flag.png": "a4a0",
	"./segob-mx.png": "f2c0",
	"./serbia-ministry-of-health.png": "d5c4",
	"./serbia-problem-gambling.png": "73bc",
	"./sicad.png": "1c83",
	"./slot-machine.png": "0802",
	"./spillemyndigheden.png": "7196",
	"./srij.png": "ce86",
	"./stopspillet.png": "fe18",
	"./take-time-to-think.png": "6a5c",
	"./tick-icon.png": "d6a1",
	"./time.png": "6245",
	"./token.png": "1efa",
	"./tracktemi.png": "a832",
	"./twitter-icon.png": "2055",
	"./uk-flag.png": "14b3",
	"./usa-flag.png": "3136",
	"./viradoojogobr.png": "994f",
	"./withdrawal.png": "e3b3",
	"./yellowcheck.png": "f73a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";